import { clearStorage } from './local-storage';

// icons
import {
  AccountCIcon,
  SettingsCIcon,
  LogoutCIcon,
  MailerCIcon,
  ContactCIcon,
  OrderDetailsCIcon,
  ReviewOrderCIcon,
  EmailCIcon,
  SpendingCIcon,
  SentCIcon,
  TransitCIcon,
  DeliveredCIcon,
  ReturnedCIcon,
  WebCIcon,
  AdminPanelCIcon,
  TemplatePostcardCIcon,
  TemplatePersonalizedCIcon,
  TemplateProfessionalCIcon,
  TemplateBiFoldCIcon,
  TemplateTrifoldCIcon,
  TemplateRealPennedCIcon,
  TemplateSnapPackCIcon,
  Settings2CIcon,
  UsersCIcon,
  EngagementCIcon,
  BillingCIcon,
  IntegrationsCIcon,
  Logout2CIcon,
  AdminPortalCIcon,
  TotalContactsCIcon,
  DeliverableContactsCIcon,
  UndelieverableContactsCIcon,
  TotalDNCCIcon,
  OrderNumberCIcon,
  OrderNameCIcon,
  TemplateIdCIcon,
  TemplateNameCIcon,
  ApiKeyCIcon,
  WebhookCIcon,
  APIKeysCIcon,
  WebhooksCIcon,
  IntegrationCIcon,
  WebhooksSVGIcon,
} from '~/assets/images';

import { setDashboardMode } from './auth';
import { isProduction } from './helperFunctions';
import { getDashboardMode } from '~/utils/auth';

const isAdminMode = JSON.parse(getDashboardMode()) || false;

// utils
import { MESSAGES } from '~/utils/message';

export const INDUSTRY_OPTIONS = [
  {
    id: 1,
    title: 'Real Estate',
  },
  {
    id: 2,
    title: 'Home Service',
  },
  {
    id: 3,
    title: 'Ecommerce',
  },
  {
    id: 4,
    title: 'Financials Services',
  },
  {
    id: 5,
    title: 'Insurance',
  },
  {
    id: 6,
    title: 'Retail',
  },
];

export const DIRECT_MAIL_OPTIONS = [
  {
    id: 1,
    title: 'Yes, with OLC',
  },
  {
    id: 2,
    title: 'Yes, with another vendor',
  },
  {
    id: 3,
    title: 'Yes, but looking for better results',
  },
  {
    id: 4,
    title: 'Not yet',
  },
];

export const ANNUAL_REVENUE_OPTIONS = [
  {
    id: 1,
    title: 'Less than $1,000',
  },
  {
    id: 2,
    title: '$1,000-$5,000',
  },
  {
    id: 3,
    title: '$5,000-$10,000',
  },
  {
    id: 4,
    title: '$10,000+',
  },
];

export const COMPANY_OPTIONS = [
  {
    id: 1,
    title: '1-5',
  },
  {
    id: 2,
    title: '6-10',
  },
  {
    id: 3,
    title: '11-25',
  },
  {
    id: 4,
    title: '26-100',
  },
  {
    id: 5,
    title: '100+',
  },
];

export const ROLE_OPTIONS = [
  {
    id: 1,
    title: 'Business Owner',
  },
  {
    id: 2,
    title: 'Executive',
  },
  {
    id: 3,
    title: 'Marketing Manager',
  },
  {
    id: 4,
    title: 'Admin Assistant',
  },
  {
    id: 5,
    title: 'Other',
  },
];

export const ABOUT_OPTIONS = [
  {
    id: 1,
    title: 'Facebook',
  },
  {
    id: 2,
    title: 'Instagram',
  },
  {
    id: 3,
    title: 'Tiktok',
  },
  {
    id: 4,
    title: 'Google/Bing',
  },
  {
    id: 5,
    title: 'Friend',
  },
  {
    id: 6,
    title: 'Podcast',
  },
  {
    id: 7,
    title: 'LinkedIn',
  },
  {
    id: 8,
    title: 'Youtube',
  },
  {
    id: 9,
    title: 'Other',
  },
];

export const GENERAL_NAVIGATION = [
  { id: 1, title: 'Dashboard', link: '/overview', childrens: [] },
  { id: 2, title: 'Orders', link: '/orders', childrens: [] },
  {
    id: 3,
    title: 'Templates',
    link: '/templates',
    childrens: [
      '/create-template',
      '/template-builder',
      '/html-template-builder',
      '/template-html',
      '/hire-a-designer',
    ],
  },
  {
    id: 4,
    title: 'Campaigns',
    link: '/campaigns',
    childrens: ['/campaigns/create'],
  },
  { id: 5, title: 'Contacts', link: '/contacts', childrens: [] },
];

export const ADMIN_NAVIGATION = [
  { id: 1, title: 'Dashboard', link: '/admin/overview', childrens: [] },
  { id: 2, title: 'Orders', link: '/admin/orders', childrens: [] },
  { id: 3, title: 'Users', link: '/admin/users', childrens: [] },
  { id: 4, title: 'Batches', link: '/admin/batches', childrens: [] },
  { id: 5, title: 'Categories', link: '/admin/categories', childrens: [] },
  { id: 6, title: 'Lookups', link: '/admin/lookups', childrens: [] },
  {
    id: 7,
    title: 'Designer Queries',
    link: '/admin/designer-queries',
    childrens: [],
  },
  {
    id: 8,
    title: 'Pricing Controls',
    link: '/admin/pricing-controls/postage',
    childrens: [],
  },
  // {
  //   id: 9,
  //   title: 'Security Settings',
  //   link: '/admin/security-settings',
  //   childrens: [],
  // },
];

export const ADMIN_PRICING_CONTROLS_NAVIGATION = [
  { id: 1, title: 'Postage', link: '/admin/pricing-controls/postage' },
  { id: 2, title: 'Cost of Goods', link: '/admin/pricing-controls/cost-of-good' },
  { id: 3, title: 'Pricing', link: '/admin/pricing-controls/pricing' },
  { id: 4, title: 'Plans', link: '/admin/pricing-controls/plans' },
];

export const DEFAULT_PAGINATION = {
  page: 1,
  pageSize: 20,
};

export const DEFAULT_PAGINATION_WITHOUT_PAGE_SIZE = {
  page: 1,
  pageSize: 10,
};

export const EVENT_TYPES = [
  { id: 1, title: 'All' },
  { id: 4, title: 'Contact Created' },
  { id: 5, title: 'Contact Updated' },
  { id: 6, title: 'Order Placed' },
  { id: 2, title: 'Order Canceled' },
  // { id: 3, title: 'Phone Call' },
  { id: 7, title: 'QR Code Scan' },
  // { id: 8, title: 'Website Visit' },
];

export const EVENT_TYPES_KEY = [
  { title: 'All', value: 'All' },
  { title: 'QR Code Scan', value: 'QR Code' },
  { title: 'Order Placed', value: 'Order Placed' },
  { title: 'Order Canceled', value: 'Order Canceled' },
  { title: 'Contact Created', value: 'Created' },
  { title: 'Contact Updated', value: 'Updated' },
];

export const ENGAGEMENT_TYPES = {
  QR_CODE: 'qr',
  PURL: 'purl',
};

export const DEFAULT_PAGE_SIZES = [20, 50, 100];

export const ADDRESS_STATUS = [
  { id: 1, title: 'Corrected' },
  { id: 2, title: 'Failed' },
  { id: 3, title: 'Verified' },
];

export const MAILED_STATUS = [
  {
    id: 1,
    title: 'Not Mailed',
  },
  {
    id: 2,
    title: 'Scheduled',
  },
  {
    id: 3,
    title: 'Mailed',
  },
  {
    id: 4,
    title: 'In Transit',
  },
  {
    id: 5,
    title: 'Delivered',
  },
  {
    id: 6,
    title: 'Returned to Sender',
  },
];

export const CONTACT_TYPE = [
  {
    id: 1,
    title: 'Return Address',
  },
  {
    id: 2,
    title: 'Do Not Contact',
  },
];

export const dragDrop = {
  baseStyle: {},
  focusedStyle: {
    border: '1.5px solid #ED5C2F',
  },
  acceptStyle: {
    border: '1.5px solid #03A155',
  },
  rejectStyle: {
    border: '1.5px solid #F00',
  },
};

export const SAMPLE_CSV = `First Name,Last Name,Company,Mailing Address 1,Mailing Address 2,Mailing City,Mailing State,Mailing Zip Code,Contact Phone Number,Contact Email
Alia Test,Walter Test,Dooley,19021 Adalberto Prairie,Suite 253,North Columbus,Nebraska,24604,208-495-6500,Nichole.OConnell21@gmail.com
Greyson Test,Allen Test,Mertz LLC,2724 Erna Knolls,Suite 024,Mafaldaton,Washington,17482,997-670-2200,Cathy26@yahoo.com`;

export const SAMPLE_PROPERTY_ADDRESS_CSV = `Property Address,Property City,Property State,Property Zip Code
317 Beechgrove Dr,Englewood,OH,45322-1105
1712 Royalsborough Rd,Durham,ME,04222`;

export const ROLES = {
  ORGANIZATION_ADMIN: 'organization-admin',
  ORGANIZATION_USER: 'organization-user',
};

export const MODE_SWITCHING_URL =
  'https://help.openletterconnect.com/olc-help-docs/getting-started/setting-up-your-account/test-mode-vs.-live-mode';

export const Barcode =
  'https://api.openletterconnect.com/api/v1/download/s3/openletterconnect/assets/preview/one-barcode.png';
export const TERMS_URL = 'https://openletterconnect.com/terms/';
export const HELP_CENTER_URL = 'https://help.openletterconnect.com/olc-help-docs';
export const CAMPAIGN_BUILDER_LEARN_URL =
  'https://help.openletterconnect.com/olc-help-docs/campaign-builder-multi-touch-mail-automation/how-it-works';
export const GENERAL_SETTINGS_LEARN_URL =
  'https://help.openletterconnect.com/olc-help-docs/getting-started/setting-up-your-account/property-address-set-up';
export const ADDRESS_STRICTNESS_LEARN_URL =
  'https://help.openletterconnect.com/olc-help-docs/getting-started/setting-up-your-account/address-strictness';
export const RETURN_ADDRESS_LEARN_URL =
  'https://help.openletterconnect.com/olc-help-docs/getting-started/setting-up-your-account/return-address-configuration';
export const SENDER_PROFILE_LEARN_URL =
  'https://help.openletterconnect.com/olc-help-docs/product-and-order-guide/sender-fields-and-sender-profiles';
export const TRACKING_PHONE_NUMBER_LEARN_URL =
  'https://help.openletterconnect.com/olc-help-docs/product-and-order-guide/tracking-number';
export const PRODUCT_LEARN_URL =
  'https://help.openletterconnect.com/getting-support/designing-your-mailers/olc-mailing-templates';
export const ENVELOPE_LEARN_URL =
  'https://help.openletterconnect.com/olc-help-docs/product-and-order-guide/products-and-specs';
export const GOOGLE_STREET_VIEW_IMAGE_URL =
  'https://api.openletterconnect.com/api/v1/download/s3/openletterconnect/default_images/dummyGSV.png';

export const USER_ROLES = [
  {
    id: 1,
    title: 'Admin',
    value: ROLES.ORGANIZATION_ADMIN,
  },
  {
    id: 2,
    title: 'User',
    value: ROLES.ORGANIZATION_USER,
  },
];

export const USER_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Active',
  BLOCKED: 'Blocked',
  INACTIVE: 'Inactive',
  INVITED: 'Invite Pending',
};

export const DESIGNER_QUERY_STATUS = {
  PENDING: 'Pending',
  IN_PROGRESS: 'In progress',
  SUBMITTED_FOR_APPROVAL: 'Submitted for approval',
  AWAITING_APPROVAL: 'Awaiting approval',
  REVISION_REQUESTED: 'Revision requested',
  PUBLISHED: 'Published',
};

export const DESIGNER_QUERY_PROOF_PREVIEW_STATUSES = [
  DESIGNER_QUERY_STATUS.SUBMITTED_FOR_APPROVAL,
  DESIGNER_QUERY_STATUS.PUBLISHED,
];

export const HEADERS_DROPDOWN = [
  {
    id: 1,
    name: 'Account',
    image: AccountCIcon,
    func: (handleAfterClick) => {
      handleAfterClick('/account/profile');
    },
  },
  {
    id: 2,
    name: 'Settings',
    image: SettingsCIcon,
    func: (handleAfterClick) => {
      handleAfterClick('/settings/general');
    },
  },
  {
    id: 3,
    name: 'Admin Portal',
    image: AdminPanelCIcon,
    func: (handleAfterClick) => {
      setDashboardMode(true);
      handleAfterClick('/admin/overview');
    },
  },
  {
    id: 4,
    name: 'Logout',
    image: LogoutCIcon,
    func: (handleAfterClick) => {
      clearStorage();
      handleAfterClick('/login');
    },
  },
];

export const DROPDOWN_ITEMS = [
  // {
  //   id: 0,
  //   name: 'Company Settings',
  //   image: Settings2CIcon,
  //   func: (handleAfterClick) => {
  //     handleAfterClick('/');
  //   },
  // },
  {
    id: 1,
    name: 'Manage Users',
    image: UsersCIcon,
    func: (handleAfterClick) => {
      handleAfterClick('/account/users');
    },
  },
  // {
  //   id: 2,
  //   name: 'Engagement',
  //   image: EngagementCIcon,
  //   func: (handleAfterClick) => {
  //     handleAfterClick('/');
  //   }
  // },
  {
    id: 2,
    name: 'Billing & Plans',
    image: BillingCIcon,
    func: (handleAfterClick) => {
      handleAfterClick('/account/plan');
    },
  },

  {
    id: 6,
    name: 'Integrations',
    image: IntegrationCIcon,
    func: (handleAfterClick) => {
      handleAfterClick('/settings/api-keys');
    },
  },

  {
    id: 7,
    name: 'Webhooks',
    image: WebhooksSVGIcon,
    func: (handleAfterClick) => {
      handleAfterClick('/settings/webhooks');
    },
  },

  // {
  //   id: 4,
  //   name: 'Integrations',
  //   image: IntegrationsCIcon,
  //   func: (handleAfterClick) => {
  //     handleAfterClick('/');
  //   },
  // },
  {
    id: 3,
    name: 'Back to Account',
    image: WebCIcon,
    func: (handleAfterClick) => {
      setDashboardMode(false);
      handleAfterClick('/overview');
    },
  },
  {
    id: 4,
    name: 'Admin Portal',
    image: AdminPortalCIcon,
    func: (handleAfterClick) => {
      setDashboardMode(true);
      handleAfterClick('/admin/overview');
    },
  },
  {
    id: 5,
    name: 'Logout',
    image: Logout2CIcon,
    func: (handleAfterClick) => {
      clearStorage();
      handleAfterClick('/login');
    },
  },
];

export const ADMIN_HEADERS_DROPDOWN = [
  {
    id: 1,
    name: 'Back to Account',
    image: WebCIcon,
    func: (handleAfterClick) => {
      setDashboardMode(false);
      handleAfterClick('/overview');
    },
  },
  {
    id: 2,
    name: 'Logout',
    image: LogoutCIcon,
    func: (handleAfterClick) => {
      clearStorage();
      handleAfterClick('/login');
    },
  },
];

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\\-]).{8,}$/;
export const EMAIL_REGEX = /^[a-z0-9](\.?[a-z0-9_\-\+])*@[a-z0-9](\.?[a-z0-9-])*\.[a-z]{2,}$/i;
export const PHONE_NO_REGEX =
  /^(?:\(\d{3}\)\s?\d{3}-\d{4}|\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9})$/;

export const CREATE_ORDER_TABS = [
  {
    id: 1,
    image: MailerCIcon,
    name: 'Mailer Details',
  },
  {
    id: 2,
    image: ContactCIcon,
    name: 'Add Contacts',
  },
  {
    id: 3,
    image: OrderDetailsCIcon,
    name: 'Order Details',
  },
  {
    id: 4,
    image: ReviewOrderCIcon,
    name: 'Review Order',
  },
];

export const CONTACTS_OPTION_TYPE = {
  Single: 'contactId',
  SingleArray: 'contactIds',
  Multiple: 'tag',
  Upload: 'reqId',
};

export const TRANSACTION_STATUS = {
  Credited: '+',
  Debited: '-',
};

export const MIN_FUNDING_LIMIT = 50;

export const dashboardStats = [
  {
    id: 1,
    title: 'Mailed',
    value: 'mailed',
    percentage: 'mailedRatio',
    image: SentCIcon,
  },
  {
    id: 2,
    title: 'In Transit',
    value: 'inTransit',
    percentage: 'inTransitRatio',
    image: TransitCIcon,
  },
  {
    id: 3,
    title: 'Delivered',
    value: 'delivered',
    percentage: 'deliveredRatio',
    image: DeliveredCIcon,
  },
  {
    id: 4,
    title: 'Returned to Sender',
    value: 'returnedToSender',
    percentage: 'returnedToSenderRatio',
    image: ReturnedCIcon,
  },
];

export const currentCardData = [
  {
    id: 1,
    name: 'Total Mailings',
    subTitle: '',
    value: 'currentMailings',
    img: EmailCIcon,
  },
  {
    id: 2,
    name: 'Total Spend',
    subTitle: '',
    value: 'currentSpend',
    img: SpendingCIcon,
  },
];

export const chartColors = {
  Mailed: '#ED5C2F',
  'In Transit': '#F28230',
  Delivered: '#FAB331',
  'Returned to Sender': '#FFC0B8',
};

export const DASHBOARD_DATE_OPTIONS = [
  {
    id: 1,
    title: 'Today',
  },
  {
    id: 2,
    title: 'Last 48 hours',
  },
  {
    id: 3,
    title: 'Last 7 Days',
  },
  {
    id: 4,
    title: 'Last 14 Days',
  },
  {
    id: 5,
    title: 'Last 30 Days',
  },
  {
    id: 6,
    title: 'Last 90 Days',
  },
  {
    id: 7,
    title: 'Last 180 Days',
  },
  {
    id: 8,
    title: 'Last Year',
  },
  {
    id: 9,
    title: 'Last 2 Years',
  },
];

export const sortOrderForTemplates = [
  'Postcards',
  'Personal Letters',
  'Professional Letters',
  'Bi-Fold Self-Mailers',
  'Tri-Fold Self-Mailers',
  'Real Penned Letter',
];

export const PRODUCT_PRICING_HEADERS = [
  'Features',
  'Starter',
  'Growth',
  'Professional',
  'Enterprise',
];

export const INVOICE_HEADERS = ['Date', 'Description', 'Amount', 'Status'];

export const statesData = [
  {
    state: 'Alaska',
    nick: 'AK',
    latitude: 64.2008,
    longitude: -149.4937,
  },
  {
    state: 'Alabama',
    nick: 'AL',
    latitude: 32.8067,
    longitude: -86.7911,
  },
  {
    state: 'Arkansas',
    nick: 'AR',
    latitude: 34.7465,
    longitude: -92.2896,
  },
  {
    state: 'Arizona',
    nick: 'AZ',
    latitude: 34.0489,
    longitude: -111.0937,
  },
  {
    state: 'California',
    nick: 'CA',
    latitude: 35.7783,
    longitude: -118.4179,
  },
  {
    state: 'Colorado',
    nick: 'CO',
    latitude: 39.5501,
    longitude: -105.7821,
  },
  // {
  //   "state":"Connecticut",
  //   "nick": "CT",
  //   "latitude":41.6032,
  //   "longitude":-72.6851
  // },
  {
    state: 'Delaware',
    nick: 'DE',
    latitude: 38.9108,
    longitude: -72.5277,
  },
  {
    state: 'Florida',
    nick: 'FL',
    latitude: 27.9944,
    longitude: -81.7603,
  },
  {
    state: 'Georgia',
    nick: 'GA',
    latitude: 32.6781,
    longitude: -83.222,
  },
  {
    state: 'Hawaii',
    nick: 'HI',
    latitude: 20.7984,
    longitude: -156.3319,
  },
  {
    state: 'Iowa',
    nick: 'IA',
    latitude: 41.878,
    longitude: -93.0977,
  },
  {
    state: 'Idaho',
    nick: 'ID',
    latitude: 44.0682,
    longitude: -114.742,
  },
  {
    state: 'Illinois',
    nick: 'IL',
    latitude: 40.6331,
    longitude: -89.3985,
  },
  {
    state: 'Indiana',
    nick: 'IN',
    latitude: 39.7684,
    longitude: -86.1581,
  },
  {
    state: 'Kansas',
    nick: 'KS',
    latitude: 38.5267,
    longitude: -96.7265,
  },
  {
    state: 'Kentucky',
    nick: 'KY',
    latitude: 37.8223,
    longitude: -85.7682,
  },
  {
    state: 'Louisiana',
    nick: 'LA',
    latitude: 30.9843,
    longitude: -91.9623,
  },
  // {
  //   "state":"Massachusetts",
  //   "nick": "MA",
  //   "latitude":42.4072,
  //   "longitude":-71.3824
  // },
  {
    state: 'Maryland',
    nick: 'MD',
    latitude: 39.0458,
    longitude: -76.6413,
  },
  {
    state: 'Maine',
    nick: 'ME',
    latitude: 45.2538,
    longitude: -69.4455,
  },
  {
    state: 'Michigan',
    nick: 'MI',
    latitude: 44.3148,
    longitude: -85.6024,
  },
  {
    state: 'Minnesota',
    nick: 'MN',
    latitude: 46.7296,
    longitude: -94.6859,
  },
  {
    state: 'Missouri',
    nick: 'MO',
    latitude: 38.3566,
    longitude: -92.458,
  },
  {
    state: 'Mississippi',
    nick: 'MS',
    latitude: 32.3547,
    longitude: -89.3985,
  },
  {
    state: 'Montana',
    nick: 'MT',
    latitude: 46.8797,
    longitude: -110.3626,
  },
  {
    state: 'North Carolina',
    nick: 'NC',
    latitude: 35.7596,
    longitude: -79.0193,
  },
  {
    state: 'North Dakota',
    nick: 'ND',
    latitude: 47.5515,
    longitude: -101.002,
  },
  {
    state: 'Nebraska',
    nick: 'NE',
    latitude: 41.4925,
    longitude: -99.9018,
  },
  {
    state: 'New Hampshire',
    nick: 'NH',
    latitude: 43.1939,
    longitude: -71.5724,
  },
  // {
  //   "state":"New Jersey",
  //   "nick": "NJ",
  //   "latitude":40.0583,
  //   "longitude":-74.4057
  // },
  {
    state: 'New Mexico',
    nick: 'NM',
    latitude: 34.9727,
    longitude: -105.0324,
  },
  {
    state: 'Nevada',
    nick: 'NV',
    latitude: 38.8026,
    longitude: -116.4194,
  },
  {
    state: 'New York',
    nick: 'NY',
    latitude: 43.2994,
    longitude: -74.2179,
  },
  {
    state: 'Ohio',
    nick: 'OH',
    latitude: 40.4173,
    longitude: -82.9071,
  },
  {
    state: 'Oklahoma',
    nick: 'OK',
    latitude: 35.5653,
    longitude: -96.9289,
  },
  {
    state: 'Oregon',
    nick: 'OR',
    latitude: 43.8041,
    longitude: -120.5542,
  },
  {
    state: 'Pennsylvania',
    nick: 'PA',
    latitude: 40.5908,
    longitude: -77.2098,
  },
  {
    state: 'Rhode Island',
    nick: 'RI',
    latitude: 41.5801,
    longitude: -69.4774,
  },
  {
    state: 'South Carolina',
    nick: 'SC',
    latitude: 33.8361,
    longitude: -81.1637,
  },
  {
    state: 'South Dakota',
    nick: 'SD',
    latitude: 44.4443,
    longitude: -100.2263,
  },
  {
    state: 'Tennessee',
    nick: 'TN',
    latitude: 35.5175,
    longitude: -86.5804,
  },
  {
    state: 'Texas',
    nick: 'TX',
    latitude: 31.9686,
    longitude: -99.9018,
  },
  {
    state: 'Utah',
    nick: 'UT',
    latitude: 39.3209,
    longitude: -111.0937,
  },
  {
    state: 'Virginia',
    nick: 'VA',
    latitude: 37.4316,
    longitude: -78.6569,
  },
  {
    state: 'Vermont',
    nick: 'VT',
    latitude: 44.5588,
    longitude: -72.5778,
  },
  {
    state: 'Washington',
    nick: 'WA',
    latitude: 47.0511,
    longitude: -119.7401,
  },
  {
    state: 'Wisconsin',
    nick: 'WI',
    latitude: 44.7863,
    longitude: -89.8267,
  },
  {
    state: 'West Virginia',
    nick: 'WV',
    latitude: 38.5976,
    longitude: -80.4549,
  },
  {
    state: 'Wyoming',
    nick: 'WY',
    latitude: 43.07597,
    longitude: -107.2903,
  },
];

export const DOWNLOADABLE_BATCH_STATUSES = [
  'PDF generated',
  'Submitted to Woo',
  'Ready for AccuTrace',
  'Accutrace job Ids retrieved',
  'Completed',
  'Test Batch',
];

export const TEST_BATCH_STATUS = 'Test Batch';
export const PDF_GENERATED_STATUS = 'PDF generated';
export const REAL_PENNED_LETTER_PRODUCT_TYPE = 'Real Penned Letter, First Class Forever';
export const PDF_GENERATE_FAILED_STATUS = 'PDF generate failed';

export const PDF_REGENERATION_ALLOWED_STATUSES = [
  TEST_BATCH_STATUS,
  PDF_GENERATE_FAILED_STATUS,
  PDF_GENERATED_STATUS,
];

export const CUSTOM_FIELDS_REGEX = /^[a-zA-Z0-9 _.\-()+]*$/;

export const BUFFER = 10;
export const SCROLL_THRESHOLD = 80; // Pixels near the edge to trigger scroll
export const SCROLL_SPEED = 10; // Adjust this to control scroll speed

export const DATE_REGEX = /^\d{2}\/\d{2}\/\d{4}$/; // MM/DD/YYYY format

export const PROOF_TABS = [
  {
    id: 0,
    type: 'mail_proof',
    label: 'Mailer Proof',
  },
  {
    id: 1,
    type: 'envelope_proof',
    label: 'Envelope Proof',
  },
];

export const HAS_ENVELOPE = [
  16, 38, 42, 23, 41, 24, 25, 39, 40, 17, 5, 6, 7, 8, 26, 27, 28, 29, 1, 2, 3, 4, 30, 31, 32, 33,
  34, 35, 36, 37, 45, 46, 47, 48, 49,
];

export const COMPAIGNS_ACTION_TYPE = [
  {
    type: 'send_postcard_4x6',
    label: 'Postcard 4x6',
    newLabel: 'Postcard',
    description: 'Send a personalized postcard',
    icon: TemplatePostcardCIcon,
    productId: 13,
    color: '#ed5c2f',
    title: 'Postcards',
    productType: 'Postcards',
    hasEnvelope: false,
    paper: '100# - 120# Glossy Coverstock',
    size: '4x6',
  },
  {
    type: 'send_postcard_6x9',
    label: 'Postcard 6x9',
    newLabel: 'Postcard',
    description: 'Send a personalized postcard',
    icon: TemplatePostcardCIcon,
    productId: 14,
    color: '#ed5c2f',
    title: 'Postcards',
    productType: 'Postcards',
    hasEnvelope: false,
    paper: '100# - 120# Glossy Coverstock',
    size: '6x9',
  },
  {
    type: 'send_postcard_6x11',
    label: 'Postcard 6x11',
    newLabel: 'Postcard',
    description: 'Send a personalized postcard',
    icon: TemplatePostcardCIcon,
    productId: 15,
    color: '#ed5c2f',
    title: 'Postcards',
    productType: 'Postcards',
    hasEnvelope: false,
    paper: '100# - 120# Glossy Coverstock',
    size: '6x11',
  },
  {
    type: 'send_postcard_9x12',
    label: 'Postcard 9x12',
    newLabel: 'Postcard',
    description: 'Send a personalized postcard',
    icon: TemplatePostcardCIcon,
    productId: 21,
    color: '#ed5c2f',
    title: 'Postcards',
    productType: 'Postcards',
    hasEnvelope: false,
    paper: '100# - 120# Glossy Coverstock',
    size: '9x12',
  },
  {
    type: 'send_personal_letter',
    label: 'Personal Letter',
    newLabel: 'Personal Letter',
    description: 'Send a personal letter',
    productId: 5,
    icon: TemplatePersonalizedCIcon,
    color: '#ed5c2f',
    title: 'Personal Letters',
    productType: 'Personal Letters',
    hasEnvelope: true,
    paper: '60# Statement',
    envelope: 'A6 White / A6 Grey Herringbone',
    size: '8.5x5.5',
    ink: 'Full color or black & white',
  },
  {
    type: 'send_professional_letter_windowed',
    label: 'Professional Letter (Windowed)',
    newLabel: 'Professional Letter',
    description: 'Send a professional letter (windowed)',
    productId: 2,
    icon: TemplateProfessionalCIcon,
    color: '#ed5c2f',
    title: 'Professional Letters',
    productType: 'Professional Letters',
    hasEnvelope: true,
    paper: '60# Statement',
    envelope: '#10 Double-Window',
    size: '11x8.5',
    ink: 'Full color or black & white',
  },
  {
    type: 'send_professional_letter_non_windowed',
    label: 'Professional Letter (Non-Windowed)',
    newLabel: 'Professional Letter',
    description: 'Send a professional letter (non-windowed)',
    productId: 4,
    icon: TemplateProfessionalCIcon,
    color: '#ed5c2f',
    title: 'Professional Letters',
    productType: 'Professional Letters',
    hasEnvelope: true,
    paper: '60# Statement',
    envelope: '#10 Grey',
    size: '11x8.5',
    ink: '',
  },
  {
    type: 'send_bi-fold_self-mailers',
    label: 'Bi-Fold Self-Mailers Letter',
    newLabel: 'Self Mailer',
    description: 'Send a bi-fold self-mailers letter',
    productId: 9,
    icon: TemplateBiFoldCIcon,
    color: '#ed5c2f',
    title: 'Bi-Fold Self-Mailers',
    productType: 'Bi-Fold Self-Mailers',
    hasEnvelope: false,
    paper: '80# Glossy Coverstock',
    size: '6x18',
    ink: '',
  },
  {
    type: 'send_tri-fold_self_Mailers',
    label: 'Tri-Fold Self-Mailers Letter',
    newLabel: 'Self Mailer',
    description: 'Send a tri-fold self-mailers letter',
    productId: 11,
    icon: TemplateTrifoldCIcon,
    color: '#ed5c2f',
    title: 'Tri-Fold Self-Mailers',
    productType: 'Tri-Fold Self-Mailers',
    hasEnvelope: false,
    paper: '80# Glossy Coverstock',
    size: '12x9',
    ink: '',
  },
  {
    type: 'send_personal_real_penned_letter',
    label: 'Real Penned Letter',
    newLabel: 'Real Penned Letter',
    description: 'Send a handwritten letter',
    productId: 16,
    icon: TemplateRealPennedCIcon,
    color: '#ed5c2f',
    title: 'Real Penned Letter',
    productType: 'Real Penned Letter',
    hasEnvelope: true,
    paper: '60# Statement',
    envelope: 'A6 Lavender / A6 Navy Blue',
    size: '8.5x5.5',
    ink: 'Blue or black ink options',
  },
  {
    type: 'send_professional_real_penned_letter',
    label: 'Real Penned Letter',
    newLabel: 'Real Penned Letter',
    description: 'Send a handwritten letter',
    productId: 38,
    icon: TemplateRealPennedCIcon,
    color: '#ed5c2f',
    title: 'Real Penned Letter',
    productType: 'Real Penned Letter',
    hasEnvelope: true,
    paper: '60# Statement',
    envelope: 'A6 Lavender / A6 Navy Blue',
    size: '"8.5x11',
    ink: 'Blue or black ink options',
  },
  {
    type: 'send_snap_pack',
    label: 'Snap Pack',
    newLabel: 'Snap Pack',
    description: 'Send a snap pack mailer',
    productId: 18,
    icon: TemplateSnapPackCIcon,
    color: '#ed5c2f',
    title: 'Snap Pack Mailers',
    productType: 'Snap Pack Mailers',
    hasEnvelope: false,
    paper: 'No Paper Type',
    size: '11x8.5',
    ink: '',
  },
];

export const ORDER_DETAILS_CONTACT_STATS = (info) => {
  return [
    {
      icon: TotalContactsCIcon,
      title: MESSAGES.ORDERS.DETAIL.OVERVIEW.TOTAL_CONTACTS,
      value: info.totalContacts,
    },
    {
      icon: DeliverableContactsCIcon,
      title: MESSAGES.ORDERS.DETAIL.OVERVIEW.DELIVERABLES,
      value: info.deliverableContacts,
    },
    {
      icon: UndelieverableContactsCIcon,
      title: MESSAGES.ORDERS.DETAIL.OVERVIEW.UNDELIVERABLES,
      value: info.unDeliverableContacts,
    },
    {
      icon: TotalDNCCIcon,
      title: MESSAGES.ORDERS.DETAIL.OVERVIEW.DNC,
      value: info.dncContacts,
    },
  ];
};

export const ORDER_STATS = (props) => {
  const {
    orderNumber,
    orderName,
    templateId,
    templateName,
    productType,
    rosOfferPercentage,
    isFindNewContactsPurchase,
  } = props;
  if (isFindNewContactsPurchase) {
    return [
      {
        id: 1,
        icon: OrderNumberCIcon,
        label: 'Order Number',
        value: orderNumber || '-',
        key: 'orderNumber',
      },
      {
        id: 2,
        icon: OrderNameCIcon,
        label: 'Order Name',
        value: orderName || '-',
        key: 'orderName',
      },
      {
        id: 3,
        icon: TemplateNameCIcon,
        label: 'Product Type',
        value: productType || 'Find New Contacts',
        key: 'productType',
      },
    ];
  }

  return [
    {
      id: 1,
      icon: OrderNumberCIcon,
      label: 'Order Number',
      value: orderNumber || '-',
      key: 'orderNumber',
    },
    {
      id: 2,
      icon: OrderNameCIcon,
      label: 'Order Name',
      value: orderName || '-',
      key: 'orderName',
    },
    {
      id: 3,
      icon: TemplateIdCIcon,
      label: 'Template ID',
      value: templateId || '-',
      key: 'templateId',
    },
    {
      id: 4,
      icon: TemplateNameCIcon,
      label: 'Template Name',
      value: templateName || '-',
      key: 'templateName',
    },
    {
      id: 5,
      icon: TemplateNameCIcon,
      label: 'ROS Offer',
      value: rosOfferPercentage ? `${rosOfferPercentage}%` : '-',
      key: 'rosOfferPercentage',
    },
  ];
};

export const MERGE_UTM_PARAMS = [
  {
    key: '{{C.FIRST_NAME}}',
    value: 'firstname',
  },
  {
    key: '{{C.LAST_NAME}}',
    value: 'lastname',
  },
  {
    key: '{{C.EMAIL}}',
    value: 'email',
  },
  {
    key: '{{C.PHONE_NUMBER}}',
    value: 'phone',
  },
];

export const DISALLOWED_DOMAINS = ['qrforward.org', 'demo-qrforward.org', 'staging-qrforward.org'];
